import keyBy from 'lodash/keyBy';

import {eventDefinitionsClient} from 'common/report/queries/app-api/event-definitions-client';
import {BaseClient} from 'common/report/queries/utils/base-client';
import {EventDefinition} from 'common/util/definitions-types';

import {Store} from './store';

export const eventDefinitionsStore = new Store<{[eventName: string]: EventDefinition}>({
  apiClient: eventDefinitionsClient as BaseClient,
  defaultValue: {},
  name: `event-definitions`,
  transform: {
    index: (definitions) => keyBy(definitions, `name`),
    update: (definitions) => ({k: definitions.name, v: definitions}),
  },
});
